import React from 'react'
import { RouteConstants } from '../../../setup/routeConstants'

import LazyProtectedRoute from '../../LazyProtectedRoute'

const ShopifyPayoutsPage = React.lazy(() => import("../../../components/Settings/Payouts/ShopifyPayouts"))

export default {
    path: RouteConstants.shopify.payouts.path,
    element: (
        <LazyProtectedRoute
            requiredPolicies={[]}
            component={<ShopifyPayoutsPage />}
        />
    ),
}